module.exports = __webpack_public_path__ + "img/cumt-agh-hsp.b83b1e17.png";